var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecSetupStepFour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 269,
    viewBox: "0 0 192 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57129 18.8097H187.71C189.612 18.8097 191.147 20.3457 191.147 22.2473V264.562C191.147 266.464 189.612 268 187.71 268H5.57129C3.04794 268 1 265.952 1 263.429V23.3993C1 20.8759 3.04794 18.828 5.57129 18.828V18.8097Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 188.331C169.134 188.331 169.024 188.423 169.024 188.533C169.024 188.642 169.115 188.734 169.243 188.734H173.65C173.76 188.734 173.869 188.642 173.869 188.533C173.869 188.423 173.778 188.331 173.65 188.331H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 188.551C174.911 188.441 175.002 188.35 175.13 188.35H179.537C179.647 188.35 179.756 188.441 179.756 188.551C179.756 188.661 179.665 188.752 179.537 188.752H175.13C175.02 188.752 174.911 188.661 174.911 188.551Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 190.892C169.134 190.892 169.024 190.983 169.024 191.093C169.024 191.203 169.115 191.294 169.243 191.294H173.65C173.76 191.294 173.869 191.203 173.869 191.093C173.869 190.983 173.778 190.892 173.65 190.892H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 191.111C174.911 191.001 175.002 190.91 175.13 190.91H179.537C179.647 190.91 179.756 191.001 179.756 191.111C179.756 191.221 179.665 191.312 179.537 191.312H175.13C175.02 191.312 174.911 191.221 174.911 191.111Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 193.47C169.134 193.47 169.024 193.561 169.024 193.671C169.024 193.781 169.115 193.872 169.243 193.872H173.65C173.76 193.872 173.869 193.781 173.869 193.671C173.869 193.561 173.778 193.47 173.65 193.47H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 193.671C174.911 193.561 175.002 193.47 175.13 193.47H179.537C179.647 193.47 179.756 193.561 179.756 193.671C179.756 193.781 179.665 193.872 179.537 193.872H175.13C175.02 193.872 174.911 193.781 174.911 193.671Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 196.03C169.134 196.03 169.024 196.121 169.024 196.231C169.024 196.341 169.115 196.432 169.243 196.432H173.65C173.76 196.432 173.869 196.341 173.869 196.231C173.869 196.121 173.778 196.03 173.65 196.03H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 196.231C174.911 196.121 175.002 196.03 175.13 196.03H179.537C179.647 196.03 179.756 196.121 179.756 196.231C179.756 196.341 179.665 196.432 179.537 196.432H175.13C175.02 196.432 174.911 196.341 174.911 196.231Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 198.59C169.134 198.59 169.024 198.681 169.024 198.791C169.024 198.901 169.115 198.992 169.243 198.992H173.65C173.76 198.992 173.869 198.901 173.869 198.791C173.869 198.681 173.778 198.59 173.65 198.59H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 198.791C174.911 198.681 175.002 198.59 175.13 198.59H179.537C179.647 198.59 179.756 198.681 179.756 198.791C179.756 198.901 179.665 198.992 179.537 198.992H175.13C175.02 198.992 174.911 198.901 174.911 198.791Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 201.149C169.134 201.149 169.024 201.241 169.024 201.351C169.024 201.46 169.115 201.552 169.243 201.552H170.34C170.45 201.552 170.56 201.46 170.56 201.351C170.56 201.241 170.468 201.149 170.34 201.149H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.22 201.351C178.22 201.241 178.311 201.149 178.439 201.149H179.171C179.28 201.149 179.39 201.241 179.39 201.351C179.39 201.46 179.299 201.552 179.171 201.552H178.439C178.329 201.552 178.22 201.46 178.22 201.351Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 203.71C169.134 203.71 169.024 203.801 169.024 203.911C169.024 204.02 169.115 204.112 169.243 204.112H173.65C173.76 204.112 173.869 204.02 173.869 203.911C173.869 203.801 173.778 203.71 173.65 203.71H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 203.929C174.911 203.819 175.002 203.728 175.13 203.728H179.537C179.647 203.728 179.756 203.819 179.756 203.929C179.756 204.039 179.665 204.13 179.537 204.13H175.13C175.02 204.13 174.911 204.039 174.911 203.929Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 206.269C169.134 206.269 169.024 206.361 169.024 206.47C169.024 206.58 169.115 206.672 169.243 206.672H173.65C173.76 206.672 173.869 206.58 173.869 206.47C173.869 206.361 173.778 206.269 173.65 206.269H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 206.489C174.911 206.379 175.002 206.288 175.13 206.288H179.537C179.647 206.288 179.756 206.379 179.756 206.489C179.756 206.599 179.665 206.69 179.537 206.69H175.13C175.02 206.69 174.911 206.599 174.911 206.489Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 208.83C169.134 208.83 169.024 208.921 169.024 209.031C169.024 209.14 169.115 209.232 169.243 209.232H173.65C173.76 209.232 173.869 209.14 173.869 209.031C173.869 208.921 173.778 208.83 173.65 208.83H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 209.049C174.911 208.939 175.002 208.848 175.13 208.848H179.537C179.647 208.848 179.756 208.939 179.756 209.049C179.756 209.159 179.665 209.25 179.537 209.25H175.13C175.02 209.25 174.911 209.159 174.911 209.049Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 211.408C169.134 211.408 169.024 211.499 169.024 211.609C169.024 211.718 169.115 211.81 169.243 211.81H173.65C173.76 211.81 173.869 211.718 173.869 211.609C173.869 211.499 173.778 211.408 173.65 211.408H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 211.609C174.911 211.499 175.002 211.408 175.13 211.408H179.537C179.647 211.408 179.756 211.499 179.756 211.609C179.756 211.718 179.665 211.81 179.537 211.81H175.13C175.02 211.81 174.911 211.718 174.911 211.609Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.024 216.875C169.024 216.765 169.225 216.674 169.499 216.674H179.282C179.538 216.674 179.757 216.765 179.757 216.875C179.757 216.984 179.556 217.076 179.282 217.076H169.499C169.243 217.076 169.024 216.984 169.024 216.875Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 221.976C169.134 221.976 169.024 222.068 169.024 222.178C169.024 222.287 169.115 222.379 169.243 222.379H173.65C173.76 222.379 173.869 222.287 173.869 222.178C173.869 222.068 173.778 221.976 173.65 221.976H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 222.196C174.911 222.086 175.002 221.995 175.13 221.995H179.537C179.647 221.995 179.756 222.086 179.756 222.196C179.756 222.306 179.665 222.397 179.537 222.397H175.13C175.02 222.397 174.911 222.306 174.911 222.196Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 224.555C169.134 224.555 169.024 224.646 169.024 224.756C169.024 224.865 169.115 224.957 169.243 224.957H173.65C173.76 224.957 173.869 224.865 173.869 224.756C173.869 224.646 173.778 224.555 173.65 224.555H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 224.756C174.911 224.646 175.002 224.555 175.13 224.555H179.537C179.647 224.555 179.756 224.646 179.756 224.756C179.756 224.865 179.665 224.957 179.537 224.957H175.13C175.02 224.957 174.911 224.865 174.911 224.756Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 227.115C169.134 227.115 169.024 227.206 169.024 227.316C169.024 227.426 169.115 227.517 169.243 227.517H173.65C173.76 227.517 173.869 227.426 173.869 227.316C173.869 227.206 173.778 227.115 173.65 227.115H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 227.316C174.911 227.206 175.002 227.115 175.13 227.115H179.537C179.647 227.115 179.756 227.206 179.756 227.316C179.756 227.426 179.665 227.517 179.537 227.517H175.13C175.02 227.517 174.911 227.426 174.911 227.316Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 229.674C169.134 229.674 169.024 229.766 169.024 229.876C169.024 229.985 169.115 230.077 169.243 230.077H173.65C173.76 230.077 173.869 229.985 173.869 229.876C173.869 229.766 173.778 229.674 173.65 229.674H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 229.876C174.911 229.766 175.002 229.674 175.13 229.674H179.537C179.647 229.674 179.756 229.766 179.756 229.876C179.756 229.985 179.665 230.077 179.537 230.077H175.13C175.02 230.077 174.911 229.985 174.911 229.876Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 232.234C169.134 232.234 169.024 232.326 169.024 232.435C169.024 232.545 169.115 232.636 169.243 232.636H173.65C173.76 232.636 173.869 232.545 173.869 232.435C173.869 232.326 173.778 232.234 173.65 232.234H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 232.435C174.911 232.326 175.002 232.234 175.13 232.234H179.537C179.647 232.234 179.756 232.326 179.756 232.435C179.756 232.545 179.665 232.636 179.537 232.636H175.13C175.02 232.636 174.911 232.545 174.911 232.435Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 234.794C169.134 234.794 169.024 234.886 169.024 234.996C169.024 235.105 169.115 235.197 169.243 235.197H170.34C170.45 235.197 170.56 235.105 170.56 234.996C170.56 234.886 170.468 234.794 170.34 234.794H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.22 235.014C178.22 234.904 178.311 234.813 178.439 234.813H179.171C179.28 234.813 179.39 234.904 179.39 235.014C179.39 235.124 179.299 235.215 179.171 235.215H178.439C178.329 235.215 178.22 235.124 178.22 235.014Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 237.354C169.134 237.354 169.024 237.446 169.024 237.555C169.024 237.665 169.115 237.756 169.243 237.756H173.65C173.76 237.756 173.869 237.665 173.869 237.555C173.869 237.446 173.778 237.354 173.65 237.354H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 237.574C174.911 237.464 175.002 237.372 175.13 237.372H179.537C179.647 237.372 179.756 237.464 179.756 237.574C179.756 237.683 179.665 237.775 179.537 237.775H175.13C175.02 237.775 174.911 237.683 174.911 237.574Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 239.914C169.134 239.914 169.024 240.006 169.024 240.116C169.024 240.225 169.115 240.317 169.243 240.317H173.65C173.76 240.317 173.869 240.225 173.869 240.116C173.869 240.006 173.778 239.914 173.65 239.914H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 240.134C174.911 240.024 175.002 239.933 175.13 239.933H179.537C179.647 239.933 179.756 240.024 179.756 240.134C179.756 240.244 179.665 240.335 179.537 240.335H175.13C175.02 240.335 174.911 240.244 174.911 240.134Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 242.492C169.134 242.492 169.024 242.584 169.024 242.694C169.024 242.803 169.115 242.895 169.243 242.895H173.65C173.76 242.895 173.869 242.803 173.869 242.694C173.869 242.584 173.778 242.492 173.65 242.492H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 242.694C174.911 242.584 175.002 242.492 175.13 242.492H179.537C179.647 242.492 179.756 242.584 179.756 242.694C179.756 242.803 179.665 242.895 179.537 242.895H175.13C175.02 242.895 174.911 242.803 174.911 242.694Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 245.052C169.134 245.052 169.024 245.144 169.024 245.253C169.024 245.363 169.115 245.454 169.243 245.454H173.65C173.76 245.454 173.869 245.363 173.869 245.253C173.869 245.144 173.778 245.052 173.65 245.052H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 245.253C174.911 245.144 175.002 245.052 175.13 245.052H179.537C179.647 245.052 179.756 245.144 179.756 245.253C179.756 245.363 179.665 245.454 179.537 245.454H175.13C175.02 245.454 174.911 245.363 174.911 245.253Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.488 217.058C151.488 215.119 153.061 213.565 154.981 213.565C156.901 213.565 158.473 215.138 158.473 217.058C158.473 218.977 156.901 220.55 154.981 220.55C153.061 220.55 151.488 218.977 151.488 217.058Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74805 220.075C7.74805 214.571 12.2096 210.109 17.7135 210.109C23.2173 210.109 27.6789 214.571 27.6789 220.075C27.6789 225.579 23.2173 230.04 17.7135 230.04C12.2096 230.04 7.74805 225.579 7.74805 220.075Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7135 236.038C12.2096 236.038 7.74805 240.499 7.74805 246.003C7.74805 251.507 12.2096 255.968 17.7135 255.968C23.2173 255.968 27.6789 251.507 27.6789 246.003C27.6789 240.499 23.2173 236.038 17.7135 236.038Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5398 220.075C25.5398 224.39 22.0473 227.901 17.7137 227.901C13.3802 227.901 9.8877 224.408 9.8877 220.075C9.8877 215.741 13.3802 212.249 17.7137 212.249C22.0473 212.249 25.5398 215.741 25.5398 220.075Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7137 253.829C22.029 253.829 25.5398 250.337 25.5398 246.003C25.5398 241.669 22.0473 238.177 17.7137 238.177C13.3802 238.177 9.8877 241.669 9.8877 246.003C9.8877 250.337 13.3802 253.829 17.7137 253.829Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M154.98 219.16C156.142 219.16 157.083 218.219 157.083 217.058C157.083 215.896 156.142 214.955 154.98 214.955C153.819 214.955 152.877 215.896 152.877 217.058C152.877 218.219 153.819 219.16 154.98 219.16Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1123 198.864C27.1123 200.802 25.5398 202.375 23.6016 202.375C21.6633 202.375 20.0908 200.802 20.0908 198.864C20.0908 196.926 21.6633 195.353 23.6016 195.353C25.5398 195.353 27.1123 196.926 27.1123 198.864Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6358 202.371C14.5736 202.305 16.0904 200.68 16.0238 198.742C15.9571 196.804 14.3322 195.287 12.3944 195.354C10.4566 195.421 8.93978 197.045 9.00643 198.983C9.07308 200.921 10.698 202.438 12.6358 202.371Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4845 193.872C9.72347 193.872 7.49268 196.103 7.49268 198.864C7.49268 201.625 9.72347 203.856 12.4845 203.856H23.6019C26.363 203.856 28.5938 201.625 28.5938 198.864C28.5938 196.103 26.363 193.872 23.6019 193.872H12.4845Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5835 188.314C25.5217 188.314 27.0943 186.741 27.0943 184.803C27.0943 182.865 25.5217 181.292 23.5835 181.292C21.6453 181.292 20.0728 182.865 20.0728 184.803C20.0728 186.741 21.6453 188.314 23.5835 188.314Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9951 184.803C15.9951 186.741 14.4226 188.314 12.4844 188.314C10.5462 188.314 8.97363 186.741 8.97363 184.803C8.97363 182.865 10.5462 181.292 12.4844 181.292C14.4226 181.292 15.9951 182.865 15.9951 184.803Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4375 184.803C7.4375 182.042 9.66829 179.811 12.4294 179.811H23.5467C26.3078 179.811 28.5386 182.042 28.5386 184.803C28.5386 187.564 26.3078 189.794 23.5467 189.794H12.4294C9.66829 189.794 7.4375 187.564 7.4375 184.803Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6648 166.682C15.6648 167.249 15.2991 167.725 14.8603 167.725H8.57017C8.13133 167.725 7.76562 167.267 7.76562 166.682V160.557C7.76562 159.99 8.13133 159.515 8.57017 159.515H14.8603C15.2991 159.515 15.6648 159.972 15.6648 160.557V166.682Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0077 168.127C28.0077 168.968 27.4774 169.663 26.8009 169.663H7.30887C6.65061 169.663 6.10205 168.986 6.10205 168.127V159.112C6.10205 158.271 6.63232 157.576 7.30887 157.576H26.7826C27.4408 157.576 27.9894 158.253 27.9894 159.112V168.127H28.0077Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.641 253.244C179.336 253.244 179.902 252.677 179.902 251.982V247.576H168.84V252.001C168.84 252.696 169.407 253.262 170.102 253.262H178.622L178.641 253.244Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.121 180.561C169.426 180.561 168.859 181.128 168.859 181.822V186.229H179.922V181.804C179.922 181.109 179.355 180.542 178.66 180.542H170.139L170.121 180.561Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.611 169.169C176.611 170.686 175.386 171.93 173.85 171.93C172.314 171.93 171.089 170.705 171.089 169.169C171.089 167.633 172.314 166.408 173.85 166.408C175.386 166.408 176.611 167.633 176.611 169.169Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.611 158.619C176.611 160.136 175.386 161.38 173.85 161.38C172.314 161.38 171.089 160.155 171.089 158.619C171.089 157.083 172.314 155.857 173.85 155.857C175.386 155.857 176.611 157.083 176.611 158.619Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M111.165 241.179C144.015 232.927 163.957 199.608 155.705 166.757C147.454 133.907 114.134 113.966 81.284 122.217C48.4337 130.468 28.4923 163.788 36.7438 196.638C44.9952 229.489 78.3147 249.43 111.165 241.179Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.212 127.058C66.0232 127.058 41.5576 151.524 41.5576 181.713C41.5576 211.901 66.0232 236.367 96.212 236.367C126.401 236.367 150.866 211.901 150.866 181.713C150.866 151.524 126.401 127.058 96.212 127.058ZM96.212 227.59C70.887 227.59 50.3345 207.056 50.3345 181.713C50.3345 156.369 70.8687 135.835 96.212 135.835C121.555 135.835 142.089 156.369 142.089 181.713C142.089 207.056 121.555 227.59 96.212 227.59Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M121.394 187.54C124.628 173.632 115.975 159.735 102.066 156.501C88.1578 153.267 74.2611 161.92 71.0271 175.829C67.7931 189.737 76.4464 203.634 90.3548 206.868C104.263 210.102 118.16 201.448 121.394 187.54Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M181.767 177.781H167.011C166.627 177.781 166.316 178.092 166.316 178.476V255.256C166.316 255.639 166.627 255.95 167.011 255.95H181.767C182.151 255.95 182.462 255.639 182.462 255.256V178.476C182.462 178.092 182.151 177.781 181.767 177.781Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.424 130.898C11.424 132.416 10.1989 133.659 8.66292 133.659C7.12696 133.659 5.90186 132.434 5.90186 130.898C5.90186 129.362 7.12696 128.137 8.66292 128.137C10.1989 128.137 11.424 129.362 11.424 130.898Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7817 130.898H20.8947",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0075 130.898C28.0075 132.416 26.7824 133.659 25.2464 133.659C23.7105 133.659 22.4854 132.434 22.4854 130.898C22.4854 129.362 23.7105 128.137 25.2464 128.137C26.7824 128.137 28.0075 129.362 28.0075 130.898Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3477 130.898H37.4606",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9251 117.152C14.0474 114.944 12.3565 113.054 10.1482 112.932C7.94003 112.81 6.05077 114.501 5.92847 116.709C5.80617 118.917 7.49715 120.806 9.70536 120.929C11.9136 121.051 13.8028 119.36 13.9251 117.152Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5185 73.2023C19.6173 71.4176 18.2506 69.8906 16.4659 69.7918C14.6812 69.6929 13.1543 71.0596 13.0554 72.8443C12.9566 74.6291 14.3233 76.156 16.108 76.2548C17.8927 76.3537 19.4196 74.987 19.5185 73.2023Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9576 36.9941C26.0213 35.8446 25.141 34.8611 23.9915 34.7975C22.8421 34.7338 21.8586 35.614 21.795 36.7635C21.7313 37.913 22.6115 38.8965 23.761 38.9601C24.9105 39.0238 25.8939 38.1436 25.9576 36.9941Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5281 37.0813C27.6397 35.0647 26.0955 33.3393 24.0788 33.2277C22.0622 33.116 20.3369 34.6602 20.2252 36.6769C20.1135 38.6935 21.6578 40.4188 23.6744 40.5305C25.691 40.6422 27.4164 39.098 27.5281 37.0813Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.211 120.932C27.4235 120.932 29.2154 119.14 29.2154 116.928C29.2154 114.715 27.4235 112.923 25.211 112.923C22.9985 112.923 21.2065 114.715 21.2065 116.928C21.2065 119.14 22.9985 120.932 25.211 120.932Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0006 116.928C46.0006 119.14 44.2087 120.932 41.9962 120.932C39.7836 120.932 37.9917 119.14 37.9917 116.928C37.9917 114.715 39.7836 112.923 41.9962 112.923C44.2087 112.923 46.0006 114.715 46.0006 116.928Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6655 116.928H19.542",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3457 102.483H27.4038",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7134 116.947H36.4732",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.967 94.5289C171.767 94.5289 169.17 97.1254 169.17 100.325C169.17 102.392 170.268 104.22 171.895 105.244L174.693 100.252C174.693 100.252 174.839 100.142 174.93 100.179C175.022 100.234 175.04 100.325 175.003 100.417L172.206 105.427C173.029 105.884 173.979 106.122 174.967 106.122C178.167 106.122 180.763 103.525 180.763 100.325C180.763 97.1254 178.167 94.5289 174.967 94.5289Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M182.317 45.7991V34.0596C182.317 33.6939 182.098 33.3465 181.75 33.2002C178.752 31.902 175.424 31.1888 171.95 31.1888C168.475 31.1888 165.056 31.9385 162.002 33.2551",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M162.002 66.2418V78.7489C165.038 80.0837 168.402 80.8151 171.95 80.8151C175.497 80.8151 178.733 80.102 181.75 78.8037C182.098 78.6575 182.317 78.3283 182.317 77.9443V66.2417",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M179.42 56.4233C179.649 52.2993 176.491 48.7709 172.367 48.5425C168.243 48.3141 164.714 51.4722 164.486 55.5962C164.257 59.7202 167.415 63.2485 171.539 63.4769C175.663 63.7053 179.192 60.5473 179.42 56.4233Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M177.776 56.3322C177.954 53.1157 175.491 50.3638 172.275 50.1856C169.058 50.0075 166.306 52.4706 166.128 55.6871C165.95 58.9037 168.413 61.6556 171.63 61.8337C174.846 62.0119 177.598 59.5488 177.776 56.3322Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M171.948 31.1888V41.7394",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M171.948 70.2828V80.815",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M156.664 9.61212H140.518C140.134 9.61212 139.823 9.92321 139.823 10.307V14.2748C139.823 14.6586 140.134 14.9697 140.518 14.9697H156.664C157.048 14.9697 157.359 14.6586 157.359 14.2748V10.307C157.359 9.92321 157.048 9.61212 156.664 9.61212Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M135.507 9.61212H119.361C118.978 9.61212 118.667 9.92321 118.667 10.307V14.2748C118.667 14.6586 118.978 14.9697 119.361 14.9697H135.507C135.891 14.9697 136.202 14.6586 136.202 14.2748V10.307C136.202 9.92321 135.891 9.61212 135.507 9.61212Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M114.37 9.61212H98.2246C97.8409 9.61212 97.5298 9.92321 97.5298 10.307V14.2748C97.5298 14.6586 97.8409 14.9697 98.2246 14.9697H114.37C114.754 14.9697 115.065 14.6586 115.065 14.2748V10.307C115.065 9.92321 114.754 9.61212 114.37 9.61212Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2132 9.61212H77.0674C76.6836 9.61212 76.3726 9.92321 76.3726 10.307V14.2748C76.3726 14.6586 76.6836 14.9697 77.0674 14.9697H93.2132C93.5969 14.9697 93.908 14.6586 93.908 14.2748V10.307C93.908 9.92321 93.5969 9.61212 93.2132 9.61212Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0765 9.61212H55.9307C55.5469 9.61212 55.2358 9.92321 55.2358 10.307V14.2748C55.2358 14.6586 55.5469 14.9697 55.9307 14.9697H72.0765C72.4602 14.9697 72.7713 14.6586 72.7713 14.2748V10.307C72.7713 9.92321 72.4602 9.61212 72.0765 9.61212Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9207 9.61218H34.7749C34.3912 9.61218 34.0801 9.92327 34.0801 10.307V14.2749C34.0801 14.6587 34.3912 14.9697 34.7749 14.9697H50.9207C51.3045 14.9697 51.6156 14.6587 51.6156 14.2749V10.307C51.6156 9.92327 51.3045 9.61218 50.9207 9.61218Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M161.819 78.6023V92.9561C161.819 93.2121 161.618 93.4133 161.362 93.4133H30.6046C30.3486 93.4133 30.1475 93.2121 30.1475 92.9561V18.8281M161.819 18.8281V45.8901",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M161.819 18.8098V3.76107C161.819 2.22511 160.576 1 159.058 1H33.1279C31.4823 1 30.1475 2.33481 30.1475 3.98048V18.8098",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M151.269 24.1127H41.1738V89.0067H151.269V24.1127Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5208 88.8787L30.312 93.3037",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1475 18.8097L41.4111 24.3501",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M161.635 93.3036L150.609 88.7506",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M150.501 24.4598L161.82 18.8097",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M26.253 48.5414H6.45021C6.06646 48.5414 5.75537 48.8525 5.75537 49.2362V58.8542C5.75537 59.238 6.06646 59.549 6.45021 59.549H26.253C26.6368 59.549 26.9479 59.238 26.9479 58.8542V49.2362C26.9479 48.8525 26.6368 48.5414 26.253 48.5414Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0922 24.1493H6.45021C6.06646 24.1493 5.75537 24.4604 5.75537 24.8441V34.4621C5.75537 34.8459 6.06646 35.157 6.45021 35.157H17.0922C17.4759 35.157 17.787 34.8459 17.787 34.4621V24.8441C17.787 24.4604 17.4759 24.1493 17.0922 24.1493Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M14.642 82.369H6.45021C6.06646 82.369 5.75537 82.68 5.75537 83.0638V86.2088C5.75537 86.5926 6.06646 86.9037 6.45021 86.9037H14.642C15.0257 86.9037 15.3368 86.5926 15.3368 86.2088V83.0638C15.3368 82.68 15.0257 82.369 14.642 82.369Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5126 99.4841H6.90724C6.52349 99.4841 6.2124 99.7952 6.2124 100.179V104.787C6.2124 105.171 6.52349 105.482 6.90724 105.482H17.5126C17.8964 105.482 18.2075 105.171 18.2075 104.787V100.179C18.2075 99.7952 17.8964 99.4841 17.5126 99.4841Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7459 98.8622H30.8423C30.4585 98.8622 30.1475 99.1733 30.1475 99.5571V105.372C30.1475 105.756 30.4585 106.067 30.8423 106.067H42.7459C43.1297 106.067 43.4408 105.756 43.4408 105.372V99.5571C43.4408 99.1733 43.1297 98.8622 42.7459 98.8622Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2699 82.369H18.0781C17.6944 82.369 17.3833 82.68 17.3833 83.0638V86.2088C17.3833 86.5926 17.6944 86.9037 18.0781 86.9037H26.2699C26.6536 86.9037 26.9647 86.5926 26.9647 86.2088V83.0638C26.9647 82.68 26.6536 82.369 26.2699 82.369Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M185.864 127.661H163.885C163.501 127.661 163.19 127.973 163.19 128.356V144.959C163.19 145.343 163.501 145.654 163.885 145.654H185.864C186.247 145.654 186.558 145.343 186.558 144.959V128.356C186.558 127.973 186.247 127.661 185.864 127.661Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M185.864 112.028H163.885C163.501 112.028 163.19 112.339 163.19 112.722V118.738C163.19 119.122 163.501 119.433 163.885 119.433H185.864C186.247 119.433 186.558 119.122 186.558 118.738V112.722C186.558 112.339 186.247 112.028 185.864 112.028Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M171.93 129.819H165.566C165.183 129.819 164.872 130.13 164.872 130.514V135.798C164.872 136.182 165.183 136.493 165.566 136.493H171.93C172.313 136.493 172.624 136.182 172.624 135.798V130.514C172.624 130.13 172.313 129.819 171.93 129.819Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M184.2 129.819H177.836C177.453 129.819 177.142 130.13 177.142 130.514V135.798C177.142 136.182 177.453 136.493 177.836 136.493H184.2C184.583 136.493 184.895 136.182 184.895 135.798V130.514C184.895 130.13 184.583 129.819 184.2 129.819Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M181.072 139.346H168.693C168.31 139.346 167.999 139.657 167.999 140.041V142.326C167.999 142.71 168.31 143.021 168.693 143.021H181.072C181.456 143.021 181.767 142.71 181.767 142.326V140.041C181.767 139.657 181.456 139.346 181.072 139.346Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.221 127.204V131.136C149.221 131.227 149.148 131.3 149.056 131.3C148.965 131.3 148.892 131.227 148.892 131.136V127.204C146.752 127.296 145.052 129.051 145.052 131.209C145.052 133.366 146.844 135.213 149.056 135.213C151.269 135.213 153.061 133.421 153.061 131.209C153.061 128.996 151.36 127.296 149.221 127.204Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.304 115.63C151.304 114.112 152.529 112.869 154.065 112.869C155.601 112.869 156.826 114.094 156.826 115.63C156.826 117.166 155.601 118.391 154.065 118.391C152.529 118.391 151.304 117.166 151.304 115.63Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.061 115.63C140.061 114.112 141.286 112.869 142.822 112.869C144.358 112.869 145.583 114.094 145.583 115.63C145.583 117.166 144.358 118.391 142.822 118.391C141.286 118.391 140.061 117.166 140.061 115.63Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.814 115.63C128.814 114.112 130.04 112.869 131.576 112.869C133.111 112.869 134.337 114.094 134.337 115.63C134.337 117.166 133.111 118.391 131.576 118.391C130.04 118.391 128.814 117.166 128.814 115.63Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M171.071 93.5598L171.455 94.218",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M178.495 106.414L178.879 107.073",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M168.218 96.4124L168.877 96.7963",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M181.073 103.836L181.732 104.22",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M167.158 100.307H167.926",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M182.006 100.307H182.774",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M168.218 104.22L168.877 103.836",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M181.073 96.7963L181.732 96.4124",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M171.071 107.073L171.437 106.414",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M178.495 94.218L178.879 93.5598",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M149.057 125.595V126.235",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M146.897 126.016L147.117 126.546",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M145.088 127.241L145.472 127.625",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M152.62 134.775L153.699 135.853",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M143.863 129.051L144.394 129.271",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M153.701 133.129L154.231 133.348",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M143.442 131.209H144.009",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M154.084 131.209H154.651",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M143.863 133.348L144.394 133.129",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M153.701 129.271L154.231 129.051",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M144.412 135.835L145.472 134.775",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M152.62 127.625L153.004 127.241",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M150.976 126.546L151.195 126.016",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M186.212 56.7993C186.648 48.9244 180.618 42.1869 172.743 41.7507C164.868 41.3146 158.13 47.3449 157.694 55.2199C157.258 63.0949 163.288 69.8323 171.163 70.2685C179.038 70.7046 185.776 64.6743 186.212 56.7993Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0552 157.576V169.827",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9873 140.736V148.123",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M174.855 112.192V119.415",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2134 104.348H41.3743",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4779 98.8622H47.5742C47.1905 98.8622 46.8794 99.1733 46.8794 99.5571V105.372C46.8794 105.756 47.1905 106.067 47.5742 106.067H59.4779C59.8616 106.067 60.1727 105.756 60.1727 105.372V99.5571C60.1727 99.1733 59.8616 98.8622 59.4779 98.8622Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9253 104.348H58.1044",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1893 98.8622H64.2857C63.9019 98.8622 63.5908 99.1733 63.5908 99.5571V105.372C63.5908 105.756 63.9019 106.067 64.2857 106.067H76.1893C76.5731 106.067 76.8841 105.756 76.8841 105.372V99.5571C76.8841 99.1733 76.5731 98.8622 76.1893 98.8622Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6567 104.348H74.8359",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9212 98.8622H81.0176C80.6338 98.8622 80.3228 99.1733 80.3228 99.5571V105.372C80.3228 105.756 80.6338 106.067 81.0176 106.067H92.9212C93.305 106.067 93.6161 105.756 93.6161 105.372V99.5571C93.6161 99.1733 93.305 98.8622 92.9212 98.8622Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3892 104.348H91.55",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M109.651 98.8622H97.7471C97.3633 98.8622 97.0522 99.1733 97.0522 99.5571V105.372C97.0522 105.756 97.3633 106.067 97.7471 106.067H109.651C110.034 106.067 110.346 105.756 110.346 105.372V99.5571C110.346 99.1733 110.034 98.8622 109.651 98.8622Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1006 104.348H108.28",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M126.363 98.8622H114.459C114.076 98.8622 113.765 99.1733 113.765 99.5571V105.372C113.765 105.756 114.076 106.067 114.459 106.067H126.363C126.747 106.067 127.058 105.756 127.058 105.372V99.5571C127.058 99.1733 126.747 98.8622 126.363 98.8622Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M115.833 104.348H125.012",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M143.095 98.8622H131.191C130.807 98.8622 130.496 99.1733 130.496 99.5571V105.372C130.496 105.756 130.807 106.067 131.191 106.067H143.095C143.478 106.067 143.789 105.756 143.789 105.372V99.5571C143.789 99.1733 143.478 98.8622 143.095 98.8622Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M132.562 104.348H141.742",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M159.827 98.8622H147.923C147.539 98.8622 147.228 99.1733 147.228 99.5571V105.372C147.228 105.756 147.539 106.067 147.923 106.067H159.827C160.21 106.067 160.521 105.756 160.521 105.372V99.5571C160.521 99.1733 160.21 98.8622 159.827 98.8622Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M149.293 104.348H158.454",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4669 145.032L26.4726 144.539L25.4669 144.045L24.4795 143.551V144.539V145.526L25.4669 145.032Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35693 144.539L10.3626 145.032L11.3683 145.526V144.539V143.551L10.3626 144.045L9.35693 144.539Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8243 140.736H6.66909C6.43683 140.736 6.24854 140.924 6.24854 141.156V147.72C6.24854 147.953 6.43683 148.141 6.66909 148.141H14.8243C15.0565 148.141 15.2448 147.953 15.2448 147.72V141.156C15.2448 140.924 15.0565 140.736 14.8243 140.736Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3057 140.736H21.1505C20.9183 140.736 20.73 140.924 20.73 141.156V147.72C20.73 147.953 20.9183 148.141 21.1505 148.141H29.3057C29.538 148.141 29.7263 147.953 29.7263 147.72V141.156C29.7263 140.924 29.538 140.736 29.3057 140.736Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecSetupStepFour);
export default __webpack_public_path__ + "static/media/rec-setup-step-four.6a960ac15b2bc826c90afd59eec93a29.svg";
export { ForwardRef as ReactComponent };